export default "__VITE_ASSET__Bm$PD0xz__"